import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const location = useLocation();

  const navbarStyle = {
    minHeight: '60px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 0',
    flexWrap: 'wrap', // Allows items to wrap on smaller screens
    
  };

  const navbarBrandStyle = {
    fontFamily: 'Garamond, serif',
    fontSize: '1.75rem',
    color: '#1d1e1e',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0, // Prevents shrinking
  };

  const logoStyle = {
    height: 'auto',
    width: 'clamp(50px, 6vw, 60px)',
  
  };

  // Inline style for toggler on small screens
  const togglerStyle = {
    marginLeft: 'auto', // Pushes the toggler to the right
   marginRight: '10px',
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light  "
      style={navbarStyle}
    >
      <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
        <Link to="/" className="navbar-brand ml-2" style={navbarBrandStyle}>
          <img src="/thedata/LogoTDRS.png" alt="Logo" style={logoStyle} />
          <h3 style={{ margin: 0, fontSize: 'inherit' }}>The Dry Fruit Shop</h3>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
          style={togglerStyle} // Apply the fix here
        >
          <span className="navbar-toggler-icon"></span>
        </button>
      </div>

      <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div className="navbar-nav ml-auto">
          <div className="btn-group mx-lg">
            {location.pathname !== "/publicForm" && (
              <Link to="/publicForm" className="btn btn-success ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow">
                Sign-up
              </Link>
            )}
            <Link to="/login" className="btn btn-primary ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow">
              Log-in
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}